import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { SetStateAction, useEffect, useState } from "react";
import Select from "react-select";
import UnForm from "../../../Components/Form";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ListarEtapasEntregaDeChavesController } from "../../../Controllers/Geral/Etapas/EtapasControllers";
import {
    // ListarBlocosEmpreendimentoEmccampController,
    ListarEmpreendimentosController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IGestaoVistoriaResponse } from "../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
//import { ListarUsuariosController } from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { IListarCasosDocumentos } from "../../../Interfaces/VistoriaEntregaChaves/GerarDocumento/GerarDocumentoInterface";
import { saveAs } from "file-saver";
//import JSZip from "jszip";

import {
    GerarDocumentoClienteVistoriaController,
    ListarCasosDocumentosVistoriaController,
} from "../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";
import { ListarClientesController } from "../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../Context/Historico";

const optionsTipoDocumento = [
    { value: 1, label: "Termo de Entrega de Chaves" },
    { value: 3, label: "CheckList" },
    { value: 4, label: "Termo de Imissão em Posse Precária" },
];

interface IGerarDocumentoGestaoVistoria {
    row?: IGestaoVistoriaResponse["Vistorias"][0];
    setShow: (value: SetStateAction<boolean>) => void;
    radioSelected?: string;
}

export default function GerarDocumentoGestaoVistoria(
    props: IGerarDocumentoGestaoVistoria
) {
    const { Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    // const [optionsBloco, setOptionsBloco] = useState<
    //     Array<{ value: string; label: string }> | undefined
    // >();

    const [optionsCliente, setOptionsCliente] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    // const [idBloco, setIdBloco] = useState<string[]>([]);
    const [idCliente, setIdCliente] = useState<number>();
    const [idUnidade, setIdUnidade] = useState<number>();

    const [selectedOptionsTipoDocumento, setSelectedOptionsTipoDocumento] =
        useState<Array<{ value: number; label: string }>>();

    const { value: lstEmpreendimentos, loading: lstEmpreendimentosLoading } =
        useAsyncEffect(() => ListarEmpreendimentosController(), []);

    const { value: lstClientes } = useAsyncEffect(async () => {
        if (idEmpreendimento.length > 0 && idUnidade) {
            const res = await ListarClientesController(0, 0, {
                ID_EMPREENDIMENTO: idEmpreendimento as number[],
                ID_UNIDADE: idUnidade,
            });
            return res;
        }
    }, [idEmpreendimento, idUnidade]);

    const disabledTipoDoc =
        selectedOptionsTipoDocumento === undefined ||
        selectedOptionsTipoDocumento?.length === 0;

    // const { execute: listarBloco } = useAsyncCallback(
    //     ListarBlocosEmpreendimentoEmccampController
    // );
    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const { value: lstEtapas, loading: lstEtapasLoading } =
        useAsyncEffect(async () => {
            if (!props.row && !Atendimento?.ID_CASO) {
                const res = await ListarEtapasEntregaDeChavesController();
                return res;
            }
        }, [props.row, Atendimento?.ID_CASO]);

    const etapasDesejadas = [58, 59, 60, 61, 74, 75, 76, 77];

    const isLoading = lstEmpreendimentosLoading || lstEtapasLoading;

    const {
        execute: ListarCasosDocumentosVistoria,
        loading: ListarCasosDocumentosVistoriaLoading,
    } = useAsyncCallback(ListarCasosDocumentosVistoriaController);

    const {
        execute: GerarDocumentoClienteVistoria,
        loading: GerarDocumentoClienteVistoriaLoading,
    } = useAsyncCallback(GerarDocumentoClienteVistoriaController);

    async function handleGerarDocumento(formData: IListarCasosDocumentos) {
        if (Atendimento?.ID_CASO) {
            await GerarDocumentoClienteVistoria(
                {
                    ...formData,
                    ID_CASOS: [Atendimento?.ID_CASO ?? 0],
                    TIPO_DOCUMENTO:
                        selectedOptionsTipoDocumento?.map(
                            (value) => value.value
                        ) ?? [],
                },
                true,
                props.radioSelected
            ).then((res) => {
                props.setShow(false);
                ReloadHistorico();
                if (res && res.DS_DOCUMENTO) {
                    const base64Documento = res.DS_DOCUMENTO;

                    const byteCharacters = atob(base64Documento);
                    const byteNumbers = new Array(byteCharacters.length);

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);

                    const blob = new Blob([byteArray], {
                        type: "application/pdf",
                    });

                    saveAs(blob, res.DS_NOME_DOCUMENTO + ".pdf");
                }
            });
        } else if (props.row) {
            await GerarDocumentoClienteVistoria(
                {
                    ...formData,
                    ID_CASOS: [props.row?.ID_CASO ?? 0],
                    TIPO_DOCUMENTO:
                        selectedOptionsTipoDocumento?.map(
                            (value) => value.value
                        ) ?? [],
                },
                false,
                ""
            ).then((res) => {
                props.setShow(false);
                if (res && res.DS_DOCUMENTO) {
                    const base64Documento = res.DS_DOCUMENTO;

                    const byteCharacters = atob(base64Documento);
                    const byteNumbers = new Array(byteCharacters.length);

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);

                    const blob = new Blob([byteArray], {
                        type: "application/pdf",
                    });

                    saveAs(blob, res.DS_NOME_DOCUMENTO + ".pdf");
                }
            });
        } else {
            await ListarCasosDocumentosVistoria({
                ...formData,
                ID_CONTA: idCliente ?? 0,
                ID_EMPREENDIMENTO: idEmpreendimento as number[],
                ID_ETAPA: formData.ID_ETAPA,
                // DS_BLOCO: idBloco,
                ID_UNIDADE: formData.ID_UNIDADE ?? 0,
            }).then(async (response) => {
                await GerarDocumentoClienteVistoria(
                    {
                        ID_CASOS: response,
                        TIPO_DOCUMENTO:
                            selectedOptionsTipoDocumento?.map(
                                (value) => value.value
                            ) ?? [],
                    },
                    false,
                    ""
                ).then(async (res) => {
                    props.setShow(false);
                    if (res && res.DS_DOCUMENTO) {
                        const base64Documento = res.DS_DOCUMENTO;

                        const byteCharacters = atob(base64Documento);
                        const byteNumbers = new Array(byteCharacters.length);

                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);

                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });

                        saveAs(blob, res.DS_NOME_DOCUMENTO + ".pdf");
                    }
                    // const zip = new JSZip();

                    // res.forEach((responseItem) => {
                    //     responseItem.DOCUMENTOS_GERADOS.forEach((documento) => {
                    //         const pdfContent = atob(documento.DS_DOCUMENTO);

                    //         zip.file(
                    //             `${responseItem.ID_CASO}_${documento.DS_NOME_DOCUMENTO}.pdf`,
                    //             pdfContent,
                    //             { binary: true }
                    //         );
                    //     });
                    // });

                    // zip.generateAsync({ type: "blob" }).then((content) => {
                    //     saveAs(content, "documentos.zip");
                    // });

                    // props.setShow(false);
                });
            });
        }
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    useEffect(() => {
        if (!props.row && !Atendimento?.ID_CASO) {
            setOptions(() =>
                lstEmpreendimentos?.map((empreendimento) => ({
                    label: empreendimento.DS_EMPREENDIMENTO,
                    value: empreendimento.ID_EMPREENDIMENTO,
                }))
            );

            setOptionsCliente(() =>
                lstClientes?.LISTA_CLIENTES?.map((usuario) => ({
                    label: usuario.DS_CONTA,
                    value: usuario.ID_CONTA,
                }))
            );
        }
    }, [props.row, lstEmpreendimentos, lstClientes, Atendimento?.ID_CASO]);

    return (
        <OrSpinner loading={isLoading} spinner="capys">
            <UnForm handleSubmit={handleGerarDocumento}>
                {!props.row && !Atendimento?.ID_CASO && (
                    <>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                options={options}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    setIdEmpreendimento(
                                        e.map((value) => value?.value)
                                    );
                                    // listarBloco(
                                    //     e.map((value) => value?.value)
                                    // ).then((response) => {
                                    //     setOptionsBloco(() =>
                                    //         response?.map((produto) => ({
                                    //             label: `${produto.DS_BLOCO} - ${produto.DS_EMPREENDIMENTO}`,
                                    //             value: produto.DS_BLOCO,
                                    //         }))
                                    //     );
                                    // });
                                    listarUnidades({
                                        ID_EMPREENDIMENTO: e.map(
                                            (value) => value?.value
                                        ),
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        {/* <div className="col-12 mt-3">
                            <label>Bloco</label>
                            <Select
                                name="ID_BLOCO"
                                options={optionsBloco}
                                isClearable
                                onChange={(e) => {
                                    setIdBloco(e.map((value) => value?.value));
                                }}
                                isMulti
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div> */}
                        <div className="col-12 mt-3">
                            <label>Unidade</label>
                            <UnForm.Select
                                className="form-control"
                                name="ID_UNIDADE"
                                onChange={(e) => {
                                    setIdUnidade(Number(e.target.value));
                                }}
                            >
                                <option value={0}></option>
                                {unidadesListadas?.map((unidade) => (
                                    <option
                                        key={unidade?.ID_PRODUTO}
                                        value={unidade?.ID_PRODUTO}
                                    >
                                        {unidade.DS_PRODUTO}
                                    </option>
                                ))}
                            </UnForm.Select>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <Select
                                name="ID_CONTA"
                                options={optionsCliente}
                                onChange={(e) => {
                                    setIdCliente(e?.value ?? 0);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <UnForm.Select
                                className="form-control"
                                name="ID_ETAPA"
                            >
                                <option value={0}></option>
                                {lstEtapas
                                    ?.filter((lst) =>
                                        etapasDesejadas.includes(
                                            lst.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        )
                                    )
                                    ?.map((unidade) => (
                                        <option
                                            key={
                                                unidade?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                            value={
                                                unidade?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                        >
                                            {
                                                unidade.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                        </option>
                                    ))}
                            </UnForm.Select>
                        </div>
                    </>
                )}{" "}
                <div className="col-12 mt-3">
                    <label>Tipo Documento</label>
                    <Select
                        options={optionsTipoDocumento}
                        isClearable
                        isMulti
                        value={selectedOptionsTipoDocumento}
                        onChange={(e) =>
                            setSelectedOptionsTipoDocumento(
                                e.map((value) => value)
                            )
                        }
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma opção"}
                    />
                </div>
                <UnForm.SubmitButton
                    color="primary"
                    icon={faPrint}
                    loadingSize="sm"
                    loading={
                        GerarDocumentoClienteVistoriaLoading ||
                        ListarCasosDocumentosVistoriaLoading
                    }
                    disabled={
                        GerarDocumentoClienteVistoriaLoading ||
                        ListarCasosDocumentosVistoriaLoading ||
                        (!props.row &&
                            !Atendimento?.ID_CASO &&
                            (idEmpreendimento.length === 0 ||
                                disabledTipoDoc)) ||
                        disabledTipoDoc
                    }
                    className="w-100 mt-2"
                >
                    Gerar
                </UnForm.SubmitButton>
            </UnForm>
        </OrSpinner>
    );
}
